<script setup lang="ts">
    import { RefreshTokensCommand } from '@keyvue/one-api-client';
    import useClient from '@composables/useClient';
    import { useRouter } from 'vue-router';
    import token from '@/utils/handover-token';

    const { client } = useClient();
    const router = useRouter();

    const authenticate = async () => {
        // The token was taken out of the URL at start-up (utils/handover-token.ts)
        const redirect = new URLSearchParams(window.location.search).get('redirect') ?? '/';

        if (token && client.session.isTokenExpired) {
            try {
                const response = await client.dispatch(
                    new RefreshTokensCommand(token),
                );

                await client.session.applyTokens(
                    response.accessToken,
                    response.refreshToken,
                );
            } catch (err) {
                // Ignore
            }
        }

        if (!client.session.isLoggedIn) {
            window.location.replace(`${import.meta.env.VITE_LEGACY_APP_HOST}/user/login?redirect=${encodeURIComponent(window.location.href)}`);
            return;
        }

        // An absolute redirect only to one-app itself (keyvue-app sends its one-app base URL plus a path), never to
        // another site: ?redirect= comes from the link, so anyone can put an address in it
        if (/^[a-z][a-z\d+.-]*:/i.test(redirect)) {
            let target = '/';
            try {
                const url = new URL(redirect);
                target = url.origin === window.location.origin ? url.href : '/';
            } catch (err) {
                // Not a valid URL: the start page
            }
            window.location.replace(target);
        } else {
            router.replace(redirect);
        }
    };

    await authenticate();
</script>
